export const colors = {
    "0": "#f8f8f8",
    "1": "#E4E4E4",
    "2": "#888888",
    "3": "#222222",
    "4": "#ffa7d1",
    "5": "#e50000",
    "6": "#e59500",
    "7": "#a06a42",
    "8": "#e5d900",
    "9": "#94e044",
    "10": "#02be01",
    "11": "#00d3dd",
    "12": "#0083c7",
    "13": "#0000ea",
    "14": "#cf6ee4",
    "15": "820080",
}